import React from 'react';
import './Clientes-Modal.css';
import ResidenciaMp4 from './assets/ResidencialColinas/Video.mp4';

const Residencia = () => {
  return (
    <div className="container">
      <h2>✅ Proyecto: Residencial Las Colinas🌞✨</h2>
      <video controls>
        <source src={ResidenciaMp4} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>
      <p>
        <span className="highlight">    Pequeños cambios generan grandes impactos: este cliente ya está
        aportando al medio ambiente mientras reduce sus gastos en energía.
        </span>{' '}
        <br/><br/>
    
         En
        esta vivienda instalamos un sistema solar fotovoltaico conectado a la
        red con una capacidad de 2.76 kWp, conformado por 8 paneles solares de
        alta eficiencia y un microinversor de 2.4 kW, tecnología que permite
        mayor seguridad eléctrica, mejor rendimiento y monitoreo individual de
        cada panel en tiempo real.<br/>
        <br />
        El objetivos del cliente en este proyecto fue claro:<br/>
        <br />
        ✔ Ser más amigable con el medio ambiente
        <br />
        ✔ Generar parte de su propio consumo eléctrico
        <br />
        ✔ Reducir el valor mensual de su factura de energía
        <br /><br/>
        Hoy, esta casa produce su propia energía limpia todos los días,
        disminuyendo su dependencia de la red eléctrica y logrando una reducción
        significativa en los costos de facturación, con posibilidad de alcanzar
        hasta el 100% de su consumo según condiciones climáticas y hábitos de
        uso.
        <br /><br/>
       <span className="highlight"> Además, este cliente cuenta con el respaldo directo de IPSUM Ingeniería
        e Innovación, lo que incluye:<br/></span>
        <br />
        🔧 Acompañamiento técnico ante cualquier eventualidad.
        <br />
        🔧 Soporte presencial y monitoreo del sistema.
        <br />
        🔧 Estructura diseñada para facilitar futuros mantenimientos,
        prolongando la vida útil del sistema.
        <br />
        🔧 Capacitación en el uso de aplicación y monitoreo del sistema.
        <br />
        <span className="highlight">
          {' '}
          En IPSUM diseñamos soluciones eficientes que generan ahorro, seguridad
          y sostenibilidad.
        </span>{' '}
      </p>
    </div>
  );
};

export default Residencia;
